import useGetApi from '../useGetApi';

export interface SupplierTag {
  id: string;
  name: string;
}

/**
 * Fetch all unique supplier tags in the organization
 */
export const useSupplierTags = () => {
  return useGetApi<SupplierTag[]>({
    endpoint: 'rebates/supplier-tags',
    options: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  });
};
